{
    "Policies_List.search.search": "FR: Search",
    "Policies_List.search.fname": "FR: First Name",
    "Policies_List.search.lname": "FR: Last Name",
    "Policies_List.search.allBrokerages": "FR: All Brokerages",
    "Policies_List.search.allBrokers": "FR: All Brokers",
    "Policies_List.search.allProducts": "FR: All Products",
    "Policies_List.search.insuredPhone": "FR: Insured Phone",
    "Policies_List.search.insuredEmail": "FR: Insured Email",
    "Policies_List.search.referenceNumber": "FR: Reference Number",
    "Policies_List.search.policyNumber": "FR: Policy Number",
    "Policies_List.search.quoteNumber": "FR: Quote Number",
    "Policies_List.search.tag": "FR: Tag",
    "Policies_List.search.doingBusinessAs": "FR: Doing Business as",
    "Policies_List.search.clear": "FR: Clear",
    "Policies_List.search.status.all": "FR: All Transaction Status",
    "Policies_List.search.status.abandoned": "FR: Abandoned",
    "Policies_List.search.status.accepted": "FR: Accepted",
    "Policies_List.search.status.bindRequested": "FR: Bind Requested",
    "Policies_List.search.status.bound": "FR: Bound",
    "Policies_List.search.status.cancelled": "FR: Cancelled",
    "Policies_List.search.status.incomplete": "FR: Incomplete",
    "Policies_List.search.status.issued": "FR: Issued",
    "Policies_List.search.status.lost": "FR: Lost",
    "Policies_List.search.status.quoted": "FR: Quoted",
    "Policies_List.search.status.quoteAccepted": "FR: Quote Accepted",
    "Policies_List.search.status.quoteIssued": "FR: Quote Issued",
    "Policies_List.search.status.referred": "FR: Referred",
    "Policies_List.search.status.rejected": "FR: Rejected",
    "Policies_List.search.status.submitted": "FR: Submitted",
    "Policies_List.search.transactionType.all": "FR: All Transaction Types",
    "Policies_List.search.transactionType.renewal": "FR: Renewal",
    "Policies_List.search.transactionType.newBusiness": "FR: New Business",
    "Policies_List.search.transactionType.endorsement": "Avenant",
    "Policies_List.search.transactionType.cancellation": "FR: Cancellation",
    "Policies_List.search.transactionType.certificate": "FR: Certificate",
    "Policies_List.table.referenceNumber": "FR: Reference #",
    "Policies_List.table.policyNumber": "FR: Policy #",
    "Policies_List.table.name": "FR: Name",
    "Policies_List.table.doingBusinessAs": "FR: Doing Business As",
    "Policies_List.table.product": "FR: Product",
    "Policies_List.table.creationDate": "FR: Creation Date",
    "Policies_List.table.brokerage": "FR: Brokerage",
    "Policies_List.table.assignedTo": "FR: Assigned To",
    "Policies_List.table.type": "FR: Type",
    "Policies_List.table.status": "FR: Status",
    "Policies_List.table.insuredName": "FR: Insured Name",
    "Policies_List.table.quoteNumber": "FR: Quote #",
    "Policies_List.table.quoteTags": "FR: Tags",
    "Policies_List.scroll.start": "FR: Scroll to start",
    "Policies_List.scroll.end": "FR: Scroll to end"
}
